import { commonEnums } from '@codametrix/ui-common';
import { noDefaultHomepageOption } from '../../reducers/state/account-settings';

const { UserPreferenceKey } = commonEnums;

const getDefaultServiceLine = (
  preferences: CMxAPI.Preference[]
): number | undefined => {
  const res = preferences?.find(
    pref => pref.keyname === UserPreferenceKey.DEFAULT_USER_SERVICE_LINE
  )?.firstValue;

  if (res?.length) {
    return parseInt(res);
  }
};

const getDefaultOrg = (preferences: CMxAPI.Preference[]) => {
  const res = preferences?.find(
    pref => pref.keyname === UserPreferenceKey.DEFAULT_USER_CONTEXT
  )?.firstValue;

  if (res?.length) {
    return parseInt(res);
  }
};

const getHomepagePreference = (preferences: CMxAPI.Preference[]) => {
  const preference = preferences?.find(
    pref => pref.keyname === UserPreferenceKey.DEFAULT_HOMEPAGE
  );
  return preference;
};

const getContextHomepage = (
  tenantId: string = 'DOES_NOT_EXIST',
  preference?: CMxAPI.Preference
) => {
  const value = preference?.values.find(value => {
    return value.tenantId && value.tenantId === tenantId;
  });

  // "None" is the account-settings sentinel for no default homepage; it is not a route.
  if (value && value.tenantId && value.value !== noDefaultHomepageOption.path) {
    return { path: value.value, tenantId: value.tenantId };
  }
};

const getDemographicsPanelLocation = (
  preferences: CMxAPI.Preference[]
): 'right' | 'bottom' | undefined => {
  const res = preferences?.find(
    pref => pref.keyname === UserPreferenceKey.DEMOGRAPHICS_PANEL_LOCATION
  )?.firstValue;

  if (res?.length) {
    return res as 'right' | 'bottom';
  }
};

const getDemographicsPanelVisibility = (
  preferences: CMxAPI.Preference[]
): 'open' | 'closed' | undefined => {
  const res = preferences?.find(
    pref => pref.keyname === UserPreferenceKey.DEMOGRAPHICS_PANEL_VISIBILITY
  )?.firstValue;

  if (res?.length) {
    return res as 'open' | 'closed';
  }
};

export {
  getDefaultServiceLine,
  getDefaultOrg,
  getHomepagePreference,
  getContextHomepage,
  getDemographicsPanelLocation,
  getDemographicsPanelVisibility
};
